function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdfcFirstBankLogoBrandlogosnetB09Qwqpa3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 235 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 235,
    height: 83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10,222H245V139H10Z",
    style: {
      fill: "#fff"
    }
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IDFC FIRST Bank logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10,222H245V139H10Z",
    transform: "translate(-10 -139)",
    style: {
      fill: "#9d1d27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,157H75V204H28V157Zm51-4H24v55H79V153Z",
    transform: "translate(-10 -139)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,171H70v-9H33Zm0,28h9v-9H33Zm0-14H56v-9H33Zm60-4h4V162H93Zm11.18-15.79v12.16h3.38c3.71,0,4.57-1.42,4.57-6.14,0-5-.54-6-5-6Zm3.9-3.18c5.83,0,7.92,2.53,7.92,9.16,0,6.38-2.22,9.35-7.95,9.35h-7.69V162ZM119,162h13v3.18h-9.18v4.34h8v3.17h-8v7.82H119Zm30.8,12.42c-.26,3.61-2.27,6.51-8,6.51s-8.39-2.76-8.39-9.58c0-6.66,2.66-9.76,8.41-9.76,4.54,0,7.33,1.94,7.95,6.17H146c-.44-1.65-1-2.92-4.13-2.92s-4.54,1.89-4.54,6.84c0,3.85,1,6,4.59,6,2.56,0,3.77-.8,4.08-3.26ZM159.93,162h13v3.18h-9.19v4.34h8v3.17h-8v7.82h-3.82Z",
    transform: "translate(-10 -139)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.41,180.54h3.82V162h-3.82Zm11.22-15.33v4.88h3.43c3.07,0,4.1-.31,4.1-2.63,0-1.86-.64-2.25-3.87-2.25h-3.66ZM182.82,162h8c3.84,0,7.2.1,7.2,5.55,0,3.61-1.5,5-3.61,5.45l4.82,7.51h-4.64l-4.54-7.28h-3.43v7.28h-3.82V162Zm21.26,12.7c.15,1.94.44,3,4.1,3,1.93,0,3.35-.28,3.35-2.17,0-1.13-.52-1.75-2.14-2.19l-4.49-1.21c-2.24-.59-4.23-1.68-4.23-5.06,0-2.66,1.21-5.45,6.94-5.45,5.44,0,7.15,2.53,7.23,5.83H211c-.18-1.55-.26-2.58-3.56-2.58-1.93,0-2.91.36-2.91,1.83s.8,1.73,1.88,2l4.13,1.11c2.63.69,4.85,1.73,4.85,5.42,0,5.22-4.46,5.71-7.22,5.71-6,0-7.69-2.38-7.92-6.22Zm17.8-9.45h-5.57V162h14.94v3.25H225.7v15.25h-3.82ZM96.78,200.16V205h3.43c3.48,0,4.26-.26,4.26-2.37s-.72-2.51-3.51-2.51H96.78Zm0-7.28V197h4.28c2.3,0,2.86-.28,2.86-2.19,0-1.55-.36-1.91-3.58-1.91H96.78Zm5.21-3.18c3.64,0,5.62,1.29,5.62,4.8,0,2.87-1.32,3.46-2.11,3.79,2.27.88,2.84,2.63,2.84,4.57,0,3-1.39,5.34-6.5,5.34H93V189.71Zm16.9,12.24-2.5.41c-1.37.21-2.35.49-2.35,1.94,0,1,.51,1.6,2.11,1.6,2.19,0,2.74-1.19,2.74-2.86Zm-8-3.2c.18-3.51,2.19-4.47,5.86-4.47s5.75,1,5.75,4v10H119v-1a5.64,5.64,0,0,1-4.18,1.37c-3.25,0-4.41-1.45-4.41-3.77,0-3,2-4.16,3.95-4.47l4.49-.7v-.82c0-1.27-.65-1.63-2.32-1.63s-2.14.41-2.32,1.58h-3.38Zm23.53,1.65c0-2.09,0-3.17-2.32-3.17-2.56,0-2.84,1.34-2.84,4.54v6.45h-3.59V194.61h3.41v1.76c1-1.32,2-2.09,4.54-2.09,3.48,0,4.39,1.49,4.39,5.63v8.31h-3.59Zm7-10.69H145v9.94l4.41-5h4.41l-4.75,5.16,4.93,8.44h-4.15l-3.3-5.91L145,203.9v4.31h-3.59Z",
    transform: "translate(-10 -139)",
    style: {
      fill: "#fefefe"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdfcFirstBankLogoBrandlogosnetB09Qwqpa3);
export default __webpack_public_path__ + "static/media/idfc-first-bank-logo-brandlogos.net_b09qwqpa3.b91d3164680667ae6d3fd12afb87e657.svg";
export { ForwardRef as ReactComponent };